import { animate, useInView, useReducedMotion } from "motion/react";
import { useEffect, useRef, useState } from "react";

type Props = {
  end: number;
  duration?: number;
  suffix?: string;
  formatter?: (v: number) => string;
};

/** Counts up once when scrolled into view. Renders the final value straight away under reduced motion. */
export function CountUp({
  end,
  duration = 1.6,
  suffix = "",
  formatter = (v) => Math.round(v).toLocaleString("en-US"),
}: Props) {
  const ref = useRef<HTMLSpanElement>(null);
  const reduce = useReducedMotion();
  const inView = useInView(ref, { once: true, margin: "-10% 0px -10% 0px" });
  const [val, setVal] = useState(end);

  useEffect(() => {
    if (!inView || reduce) return;
    const controls = animate(0, end, {
      duration,
      ease: [0.22, 1, 0.36, 1],
      onUpdate: (v) => setVal(v),
    });
    return () => controls.stop();
  }, [inView, end, duration, reduce]);

  return (
    <span ref={ref} className="tabular-nums">
      {formatter(val)}
      {suffix}
    </span>
  );
}
